<ng-template #portal>
  <div
    class="bv-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="ariaLabel || null"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
